import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import commonSelector from '@store/common/selectors';
import FeatureToggle from './FeatureToggle';

const selector = createSelector(
  commonSelector,
  commonStore => ({
    features: commonStore.features,
  }),
);

export default connect(
  selector,
  {},
)(FeatureToggle);
